<template>
    <b-overlay :show="loading" opacity="1">
        <b-modal id="create-or-update" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <incident-create-or-update
                v-model="incident"
                :has-invoice="hasInvoice"
                v-on:update-has-invoice="handleHasInvoiceChange"
                :errors="errors"
                :truck-plates="truckPlates"
                :trailer-plates="trailerPlates"
                :editing="editing"
                v-on:view-file="showFileViewer"
            ></incident-create-or-update>
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="handleCreateOrUpdate" :disabled="hasPlateError || isFormInvalid"></v-executer>
            </template>
        </b-modal>
        <div class="pb-1 row">
            <div class="col-md-3">
                <v-stats-box text="Toplam Vukuat Tutarı" :value="summaryData.totalAmount" icon="account_balance_wallet" variant="primary" />
            </div>
            <div class="col-md-3">
                <v-stats-box text="Tahsil Edilen Tutar" :value="summaryData.paidAmount" icon="check_circle_outline" variant="success" />
            </div>
            <div class="col-md-3">
                <v-stats-box text="Firmanın Karşıladığı Tutar" :value="summaryData.companyAmount" icon="business_center" variant="info" />
            </div>
            <div class="col-md-3">
                <v-stats-box text="Kalan Bakiye" :value="summaryData.remainingAmount" icon="hourglass_top" variant="warning" />
            </div>
        </div>
        <b-modal id="installments" size="lg" body-class="p-25" :title="`Taksitler - ${$safe(incidentInstallment, 'FullName') || ''}`" hide-footer no-close-on-esc no-close-on-backdrop>
            <incident-installments v-model="incidentInstallment"></incident-installments>
        </b-modal>
        <b-modal id="deposits" size="lg" body-class="p-25" :title="`Emanet - ${$safe(incident, 'FullName') || ''}`" hide-footer no-close-on-esc no-close-on-backdrop>
            <incident-deposits v-model="incident"></incident-deposits>
        </b-modal>
        <b-modal id="view-incident-modal" v-model="isViewModalVisible" size="lg" :title="`Vukuat Detayları - ${$safe(viewItemDetails, 'RefNumber')}`" hide-footer>
            <incident-detail v-if="viewItemDetails" :details="viewItemDetails" />
        </b-modal>
        <b-modal id="history-modal" size="lg" :title="`Değişiklik Geçmişi - ${incidentHistory.refNumber || ''}`" hide-footer>
            <incident-edit-history :changes="incidentHistory.changes" />
        </b-modal>
        <b-modal id="approval-history-modal" size="lg" :title="`Onay Geçmişi - ${incidentApprovalHistory.refNumber || ''}`" hide-footer>
            <incident-approval-history :approvals="incidentApprovalHistory.approvals" />
        </b-modal>

        <b-modal id="approval-modal" v-model="isApprovalModalVisible" :title="approvalRequest.title" size="lg" no-close-on-esc no-close-on-backdrop>
            <approval-request-modal-content
                v-if="isApprovalModalVisible"
                v-model="approvalRequest.form"
                :personnel="approvalRequest.allPersonnel"
                :approvers="approvalRequest.approvers"
                @search-personnel="searchAllPersonnel"
            />
            <template #modal-footer>
                <v-executer
                    :loading="loading"
                    text="Onaya Gönder"
                    :action="handleApprovalSubmit"
                    :disabled="!approvalRequest.form.selectedOrderedBy || !approvalRequest.form.selectedApprover || !approvalRequest.form.description"
                ></v-executer>
            </template>
        </b-modal>
        <b-card no-body>
            <v-table
                ref="table"
                :buttons="buttons"
                name="incident"
                :fields="fields"
                pagination="server"
                search
                button-alignment="justify-content-start"
                :items-provider="provider"
                :add-callback="createNew"
                initial-sort-by="Date"
                :initial-sort-desc="true"
                :excel-callback="exportToCsv"
            >
            <template #additional-actions>
                <div class="row">
                    <div class="col-md-3 mb-1 mb-md-0">
                        <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
                    </div>
                    <div class="col-md-3 mb-1 mb-md-0">
                        <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-4 mb-1 mb-md-0">
                        <v-select-list :options="garages" label="GarageName" v-model="garage" placeholder="Tüm Garajlar"></v-select-list>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                    </div>
                </div>
            </template>
            </v-table>
        </b-card>
    </b-overlay>
</template>

<script>
import { BCard, BBadge, BOverlay } from "bootstrap-vue";
import IncidentOperationsApi from "@/api/incident-operations";
import IncidentCreateOrUpdate from "./components/IncidentCreateOrUpdate.vue";
import VehicleOperationsApi from "@/api/vehicle-operations";
import IncidentInstallments from "./components/IncidentInstallments.vue";
import IncidentDeposits from "./components/IncidentDeposits.vue";
import moment from "moment";
import VStatsBox from "@/components/VStatsBox.vue";
import IncidentEditHistory from "./components/IncidentEditHistory.vue";
import IncidentApprovalHistory from "./components/IncidentApprovalHistory.vue";
import ApprovalRequestModalContent from "./components/ApprovalRequestModalContent.vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import IncidentDetail from "./components/IncidentDetail.vue";
import CompanyApi from '@/api/company'

export default {
    components: {
        BCard,
        BBadge,
        BOverlay,
        IncidentCreateOrUpdate,
        IncidentInstallments,
        IncidentDeposits,
        VStatsBox,
        IncidentEditHistory,
        IncidentApprovalHistory,
        ApprovalRequestModalContent,
        IncidentDetail,
    },
    data() {
        return {
            date:null,
            branch:null,
            garage:null,
            incident: {
                Id: null,
                EmployeeId: null,
                IncidentReasonId: null,
                Date: null,
                PaymentStartPeriod: moment().format("MM/YYYY"),
                CompanyAmount: null,
                EmployeeAmount: null,
                EmployeeDepositAmount: null,
                EmployeeDepositPaidAmount: null,
                EmployeeDepositPaid: null,
                InstallmentCount: null,
                TruckPlateId: null,
                TrailerPlateId: null,
                CountryId: null,
                ProvinceId: null,
                DistrictId: null,
                InvoiceNumber: null,
                BaseOperationalBranchId:null,
                Description: null,
                FullName: null,
                CaseTypeIds:[],
                Files: [],
            },
            incidentInstallment: {
                Id: null,
                FullName: null,
                IncidentInstallments: [],
            },
            incidentDeposit: {
                Id: null,
                FullName: null,
                IncidentDeposits: [],
            },
            fields: [
                { name: "Vukuat Tarihi", key: "DateStr", sortKey: "Date", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Referans No", key: "RefNumber", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Durum", key: "Status", thClass: "w-10", sortable: false, tdClass: "text-center, text-nowrap", component: true, componentOptions: { name: "incident/StatusBadge" } },
                { name: "Personel", key: "FullName", thClass: "w-20", sortable: false, tdClass: "text-nowrap" },
                { name: "TCKN", key: "EmployeeIdentityNumber", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Şube", key: "EmployeeBranchName", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Görev Yeri", key: "VehicleInventoryGarageName", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Çekici Plaka", key: "TruckPlate", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Treyler Plaka", key: "TrailerPlate", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "İl", key: "ProvinceName", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "İlçe", key: "DistrictName", thClass: "w-10", sortable: false, tdClass: "text-nowrap" },
                { name: "Ödeme Başlangıç Dönemi", key: "PaymentStartPeriod", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Taksit Sayısı", key: "InstallmentCount", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Ödenen Tutar (TL)", key: "PaidAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Kalan Tutar (TL)", key: "RemainingAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Firma Tutarı (TL)", key: "CompanyAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Sürücü Tutarı (TL)", key: "EmployeeAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Sürücü Emanet Tutarı (TL)", key: "EmployeeDepositAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
                { name: "Toplam Tutar (TL)", key: "TotalAmountStr", thClass: "w-10", sortable: false, tdClass: "text-right text-nowrap" },
            ],
            buttons: [
                { text: "Taksitler", key: "installment", icon: "CalendarIcon", variant: "success", action: this.installment },
                // { text: "Düzenleme Geçmişi", key: "history", icon: "ClockIcon", variant: "info", action: this.showHistory },
                { text: "Onay Geçmişi", key: "approval-history", icon: "CheckCircleIcon", variant: "dark", action: this.showApprovalHistory },
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit, condition: (item) => item.Status !== 3 && item.Status !== 4 },
                { text: "İncele", key: "view", icon: "EyeIcon", variant: "primary", action: this.view, condition: (item) => item.Status === 4 },
                { text: "Emanet", key: "deposit", icon: "CreditCardIcon", variant: "primary", action: this.deposit, condition: (item) => item.Status !== 3 && item.EmployeeDepositAmount > 0 },
                { text: "Pasife Al", key: "deactivate", icon: "UserXIcon", variant: "warning", action: this.deactivate, condition: (item) => item.Status !== 3 && item.Status !== 4 },
            ],
            errors: {},
            editing: false,
            loading: false,
            truckPlates: [],
            trailerPlates: [],
            summaryData: {
                totalAmount: "--,-- ₺",
                paidAmount: "--,-- ₺",
                remainingAmount: "--,-- ₺",
            },
            incidentHistory: {
                refNumber: null,
                changes: [],
            },
            incidentApprovalHistory: {
                refNumber: null,
                approvals: [],
            },
            initialFiles: [],
            updateApprovalData: {
                description: null,
            },
            hasInvoice: false,
            deactivationData: {
                item: null,
                description: "",
            },
            excelPath: null,
            searchTimer: null,
            isApprovalModalVisible: false,
            approvalRequest: {
                action: null,
                title: "",
                item: null,
                allPersonnel: [],
                approvers: [],
                form: {
                    selectedOrderedBy: null,
                    selectedApprover: null,
                    description: "",
                },
            },
            isViewModalVisible: false,
            viewItemDetails: null,
            branches:[],
            garages:[]
        };
    },
    mounted() {
        this.getPlates();
        this.getBranches()
        this.getGragages()
    },
    computed: {
        hasPlateError() {
            return !!(this.errors && (this.errors.TruckPlateId || this.errors.TrailerPlateId));
        },
        isFormInvalid() {
            const incident = this.incident;

            if (!incident.Date || !incident.EmployeeId) {
                return true;
            }

            if (this.hasInvoice && !incident.InvoiceNumber) {
                return true;
            }

            const totalAmount = (incident.CompanyAmount || 0) + (incident.EmployeeAmount || 0) + (incident.EmployeeDepositAmount || 0);
            if (totalAmount <= 0) {
                return true;
            }
            return false;
        },
    },
    methods: {
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getGragages(){
            VehicleOperationsApi.Garage.List().then(res=>{
                this.garages = res.data.Data
            })
        },      
        view(item) {
            this.$refs.table.rowLoading(true);
            IncidentOperationsApi.Get(item.Id)
                .then((res) => {
                    if (res.data.Success) {
                        let detailsData = res.data.Data;
                        if (detailsData && detailsData.Data) {
                            detailsData = detailsData.Data;
                        }
                        if (!detailsData.EmployeeBranchName && item.EmployeeBranchName) {
                            detailsData.EmployeeBranchName = item.EmployeeBranchName;
                        }
                        if (!detailsData.VehicleInventoryGarageName && item.VehicleInventoryGarageName) {
                            detailsData.VehicleInventoryGarageName = item.VehicleInventoryGarageName;
                        }

                        this.viewItemDetails = detailsData;
                        this.isViewModalVisible = true;
                    } else {
                        this.$result(res);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.$refs.table.rowLoading(false);
                });
        },
        searchAllPersonnel(searchKey) {
            if (!searchKey || searchKey.length < 2) return;

            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                EmployeeOperationsApi.Employee.Search(searchKey)
                    .then((res) => {
                        if (res.data.Success) {
                            this.approvalRequest.allPersonnel = res.data.Data;
                        }
                    })
                    .catch((err) => this.$result(null, err));
            }, 500);
        },
        async fetchIncidentApprovers(incidentId, isDeactivation) {
            this.loading = true;
            try {
                const res = await IncidentOperationsApi.GetApprovers(incidentId);
                if (res.data.Success) {
                    this.approvalRequest.approvers = res.data.Data;
                } else {
                    this.approvalRequest.approvers = [];
                    this.$result(res);
                }
            } catch (err) {
                this.approvalRequest.approvers = [];
                this.$result(null, err);
            } finally {
                this.loading = false;
            }
        },
        handleHasInvoiceChange(value) {
            this.hasInvoice = value;
            if (!value) {
                this.incident.InvoiceNumber = null;
            }
        },
        showFileViewer(url) {
            if (!url || typeof url !== "string") {
                this.$toast.error("Görüntülenecek dosya yolu bulunamadı.");
                return;
            }

            window.open(url, "_blank");
        },
        parseFileIdFromUrl(url) {
            try {
                const queryString = url.split("?")[1];
                if (!queryString) return null;

                const urlParams = new URLSearchParams(queryString);
                return urlParams.get("id");
            } catch (e) {
                console.error("URL'den ID ayrıştırılırken hata oluştu:", url, e);
                return null;
            }
        },
        provider(data) {
            return new Promise((resolve) => {
                IncidentOperationsApi.Table({
                    ...data,
                    StartDate: this.date?.[0] || null,
                    EndDate: this.date?.[1] || null,
                    OperationalBranchId: this.branch?.Id || null,
                    VehicleInventoryGarageId: this.garage?.Id || null
                })
                    .then((res) => {
                        this.handleDataRefreshed(res);

                        if (res.data.Success && res.data.Data && res.data.Data.Data) {
                            res.data.Data = res.data.Data.Data;
                        }

                        resolve(res);
                    })
                    .catch((err) => {
                        resolve(err.response);
                    });
            });
        },
        handleDataRefreshed(response) {
            if (response && response.data && response.data.Success) {
                const mainData = response.data.Data;
                const summaryDataContainer = mainData.Data;

                this.excelPath = mainData.ExcelPath;

                const formatCurrency = (value) => {
                    if (typeof value !== "number") return "--,-- ₺";
                    return value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
                };

                this.summaryData.totalAmount = formatCurrency(summaryDataContainer.TotalAmount);
                this.summaryData.paidAmount = formatCurrency(summaryDataContainer.TotalPaidAmount);
                this.summaryData.remainingAmount = formatCurrency(summaryDataContainer.TotalRemainingAmount);
                this.summaryData.companyAmount = formatCurrency(summaryDataContainer.TotalCompanyAmount);
            }
        },
        clearForm() {
            this.errors = {};
            this.editing = false;
            this.initialFiles = [];
            this.incident.Id = null;
            this.incident.EmployeeId = null;
            this.incident.FullName = null;
            this.incident.Date = null;
            this.incident.IncidentReasonId = null;
            this.incident.InvoiceNumber = null;
            this.incident.TruckPlateId = null;
            this.incident.TrailerPlateId = null;
            this.incident.CountryId = null;
            this.incident.ProvinceId = null;
            this.incident.DistrictId = null;
            this.incident.DutyFirmId = null;
            this.incident.DutyFirmName = null;
            this.incident.DutyFirmLocationId = null;
            this.incident.VehicleInventoryGarageId = null;
            this.incident.OperationalBranchId = null;
            this.incident.BaseOperationalBranchId = null;
            this.incident.Description = null;
            this.incident.CaseTypeIds = [];
            this.incident.Files = [];

            this.incident.CompanyAmount = null;
            this.incident.EmployeeAmount = null;
            this.incident.EmployeeDepositAmount = null;
            this.incident.EmployeeDepositPaidAmount = null;
            this.incident.EmployeeDepositPaid = null;
            this.incident.InstallmentCount = null;
            this.incident.PaymentStartPeriod = null;

            this.incidentInstallment.Id = null;
            this.incidentInstallment.FullName = null;
            this.incidentInstallment.IncidentInstallments = [];
            this.hasInvoice = false;
        },
        createNew() {
            this.clearForm();
            this.incident.PaymentStartPeriod = moment().add(1, "month").format("MM/YYYY");
            this.$showModal("create-or-update");
        },
        edit(item) {
            if (item.Id) {
                this.clearForm();
                this.editing = true;
                this.$refs.table.rowLoading(true);
                IncidentOperationsApi.Get(item.Id)
                    .then((res) => {
                        this.$refs.table.rowLoading(false);
                        if (res.data.Success) {
                            if (res.data.Data && res.data.Data.Data) {
                                res.data.Data = res.data.Data.Data;
                            }
                            const files = res.data.Data?.Files || [];
                            this.incident.Files = [...files];
                            this.initialFiles = [...files];
                            this.fillData(res, item);
                            this.$showModal("create-or-update");
                        } else {
                            this.$result(res);
                        }
                    })
                    .catch((err) => {
                        this.$refs.table.rowLoading(false);
                        this.$result(null, err);
                    });
            }
        },
        fillData(res, item) {
            this.incident.Id = item.Id;
            this.incident.EmployeeId = res.data.Data?.EmployeeId || null;
            this.incident.IncidentReasonId = res.data.Data?.IncidentReasonId || null;
            this.incident.Date = res.data.Data?.Date || null;
            this.incident.PaymentStartPeriod = res.data.Data?.PaymentStartPeriod || null;
            this.incident.CompanyAmount = res.data.Data?.CompanyAmount || null;
            this.incident.EmployeeAmount = res.data.Data?.EmployeeAmount || null;
            this.incident.EmployeeDepositAmount = res.data.Data?.EmployeeDepositAmount || null;
            this.incident.EmployeeDepositPaidAmount = res.data.Data?.EmployeeDepositPaidAmount || null;
            this.incident.EmployeeDepositPaid = res.data.Data?.EmployeeDepositPaid || false;
            this.incident.InstallmentCount = res.data.Data?.InstallmentCount || null;
            this.incident.TruckPlateId = res.data.Data?.TruckPlateId || null;
            this.incident.TrailerPlateId = res.data.Data?.TrailerPlateId || null;
            this.incident.DistrictId = res.data.Data?.DistrictId || null;
            this.incident.FullName = res.data.Data?.FullName || null;
            this.incident.ProvinceId = res.data.Data?.ProvinceId || null;
            this.incident.InvoiceNumber = res.data.Data?.InvoiceNumber || null;
            this.incident.Description = res.data.Data?.Description || null;
            this.incident.VehicleInventoryGarageId = res.data.Data?.VehicleInventoryGarageId || null;
            this.incident.OperationalBranchId = res.data.Data?.OperationalBranchId || null;
            this.incident.BaseOperationalBranchId = res.data.Data?.OperationalBranchId || null;
            this.incident.Files = res.data.Data?.Files || [];
            this.incident.CaseTypeIds = res.data.Data?.CaseTypeIds || [];
            this.incident.DutyFirmId = res.data.Data?.DutyFirmId || null;
            this.incident.DutyFirmLocationId = res.data.Data?.DutyFirmLocationId || null;
            this.incident.RefNumber = res.data.Data?.RefNumber || null;
            this.incident.VehicleInventoryGarageName = res.data.Data?.VehicleInventoryGarageName || null;
            this.incident.EmployeeBranchName = res.data.Data?.EmployeeBranchName || null;
        },
        handleCreateOrUpdate() {
            if (this.editing) {
                this.openApprovalModal(this.incident, "update");
            } else {
                this.submitCreateOrUpdate();
            }
        },
        async openApprovalModal(item, actionType) {
            this.approvalRequest.form = { selectedOrderedBy: null, selectedApprover: null, description: "" };
            this.approvalRequest.action = actionType;
            this.approvalRequest.item = item;

            const isDeactivation = actionType === "deactivate";
            this.approvalRequest.title = isDeactivation ? `${item.FullName} - Vukuat Pasife Alma Onayı` : `${item.FullName} - Vukuat Güncelleme Onayı`;

            await this.fetchIncidentApprovers(item.Id, isDeactivation);

            this.isApprovalModalVisible = true;
        },
        async submitCreateOrUpdate() {
            this.errors = {};
            this.loading = true;
            const fd = new FormData();

            const numericFields = ["CompanyAmount", "EmployeeAmount", "EmployeeDepositAmount"];
            for (const key in this.incident) {
                const value = this.incident[key];
                if (value === null || value === undefined || value === "") continue;
                if (numericFields.includes(key)) {
                    fd.append(key, String(value).replace(".", ","));
                } else if (key !== "Files" || key !== 'CaseTypeIds') {
                    fd.append(key, value);
                }
            }
            fd.delete('Files')
            fd.delete('CaseTypeIds')
            if (this.incident.Files && this.incident.Files.length > 0) {
                this.incident.Files.forEach((file) => {
                    if (file instanceof File) fd.append("Files", file);
                });
            }
            if (this.incident.CaseTypeIds && this.incident.CaseTypeIds.length > 0) {
                this.incident.CaseTypeIds.forEach((id) => {
                    if (id) fd.append("CaseTypeIds", id);
                });
            }

            IncidentOperationsApi.CreateOrUpdate(false, fd)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.$hideModal("create-or-update");
                        this.$refs.table.refresh();
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        showHistory(item) {
            this.incidentHistory.refNumber = item.RefNumber;
            this.incidentHistory.changes = item.Changes || [];
            this.$showModal("history-modal");
        },
        showApprovalHistory(item) {
            this.incidentApprovalHistory.refNumber = item.RefNumber;
            this.incidentApprovalHistory.approvals = item.Approvals || [];
            this.$showModal("approval-history-modal");
        },
        installment(item) {
            this.clearForm();
            this.incidentInstallment.Id = item.Id;
            this.incidentInstallment.FullName = item.FullName;
            this.incidentInstallment.IncidentInstallments = item.IncidentInstallments;
            this.$showModal("installments");
        },
        deposit(item) {
            if (item.Id) {
                this.clearForm();
                this.editing = true;
                this.$refs.table.rowLoading(true);
                IncidentOperationsApi.Get(item.Id)
                    .then((res) => {
                        this.$refs.table.rowLoading(false);
                        if (res.data.Success) {
                            this.fillData(res, item);
                            this.$showModal("deposits");
                        } else {
                            this.$result(res);
                        }
                    })
                    .catch((err) => {
                        this.$refs.table.rowLoading(false);
                        this.$result(null, err);
                    });
            }
        },
        deactivate(item) {
            this.openApprovalModal(item, "deactivate");
        },
        handleApprovalSubmit() {
            this.loading = true;
            const form = this.approvalRequest.form;
            const item = this.approvalRequest.item;
            const action = this.approvalRequest.action;

            if (action === "deactivate") {
                const requestData = {
                    Id: item.Id,
                    OrderedByEmployeeId: form.selectedOrderedBy.Id,
                    ApproverUserId: form.selectedApprover.UserId,
                    Description: form.description,
                };

                IncidentOperationsApi.Deactivate(requestData)
                    .then((res) => {
                        this.$result(res);
                        if (res.data.Success) {
                            this.isApprovalModalVisible = false;
                            this.$refs.table.refresh();
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (action === "update") {
                const fd = new FormData();
                fd.append("ChangeDescription", form.description);
                fd.append("OrderedByEmployeeId", form.selectedOrderedBy.Id);
                fd.append("ApproverUserId", form.selectedApprover.UserId);

                const numericFields = ["CompanyAmount", "EmployeeAmount", "EmployeeDepositAmount"];
                for (const key in this.incident) {
                    const value = this.incident[key];
                    if (value === null || value === undefined || value === "") continue;
                    if (numericFields.includes(key)) {
                        fd.append(key, String(value).replace(".", ","));
                    } else if (key !== "Files" || key !== 'CaseTypeIds') {
                        fd.append(key, value);
                    }
                }
                fd.delete('CaseTypeIds')

                if (this.incident.CaseTypeIds && this.incident.CaseTypeIds.length > 0) {
                    this.incident.CaseTypeIds.forEach((id) => {
                        if (id) fd.append("CaseTypeIds", id);
                    });
                }

                IncidentOperationsApi.CreateOrUpdate(true, fd)
                    .then((res) => {
                        this.$result(res);
                        if (res.data.Success) {
                            this.$hideModal("create-or-update");
                            this.isApprovalModalVisible = false;
                            this.$refs.table.refresh();
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        submitDeactivation() {
            if (!this.deactivationData.item || !this.deactivationData.description || this.deactivationData.description.length < 10) {
                return;
            }

            this.loading = true;
            const payload = {
                Id: this.deactivationData.item.Id,
                Description: this.deactivationData.description,
            };

            IncidentOperationsApi.Deactivate(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.$hideModal("deactivate-modal");
                    }
                    this.$result(res);
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getStatusText(status) {
            const statusAsNumber = parseInt(status, 10);
            switch (statusAsNumber) {
                case 0:
                    return "Ödeme Bekleniyor";
                case 1:
                    return "Diğer Ödemeler Bekleniyor";
                case 2:
                    return "Ödendi";
                case 3:
                    return "Pasif";
                case 4:
                    return "Onay Sürecinde";
                default:
                    return String(status);
            }
        },
        exportToCsv() {
            if (!this.excelPath) {
                this.$toast.warning("Dışa aktarılacak dosya yolu bulunamadı. Lütfen sayfayı yenileyip tekrar deneyin.");
                return;
            }

            let cleanUrl = String(this.excelPath);
            cleanUrl = cleanUrl.replace(/\\/g, "/");
            cleanUrl = cleanUrl.replace(/\/wwwroot/i, "");
            const finalUrl = encodeURI(cleanUrl);

            const link = document.createElement("a");
            link.setAttribute("href", finalUrl);
            link.setAttribute("download", `Vukuat_Raporu_${moment().format("YYYYMMDD")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getPlates() {
            VehicleOperationsApi.Plate.ListTruck()
                .then((res) => {
                    if (res.data.Data) {
                        this.truckPlates = res.data.Data;
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });

            VehicleOperationsApi.Plate.ListTrailer()
                .then((res) => {
                    if (res.data.Data) {
                        this.trailerPlates = res.data.Data;
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },
    },
};
</script>

<style></style>
